<div class="links-section">
    <div class="links-section__header">
        <div class="links-section__header__content">
            <div class="links-section__header__links">
                <button
                    type="button"
                    class="links-section__header__link"
                    [attr.aria-label]="'accessibility.open-regional-contacts' | translate"
                    [attr.aria-expanded]="showRegionalContacts()"
                    (click)="openContactRegional()"
                >
                    <span>{{ 'app.contactregional' | translate }}</span>
                    @if (!showRegionalContacts()) {
                        <span class="material-icons">expand_more</span>
                    }
                    @if (showRegionalContacts()) {
                        <span class="material-icons">expand_less</span>
                    }
                </button>
                <button
                    type="button"
                    class="links-section__header__link"
                    [attr.aria-label]="'accessibility.open-editorial-department' | translate"
                    [attr.aria-expanded]="showEditorialDepartment()"
                    (click)="openEditorials()"
                >
                    <span>{{ 'app.redaktion' | translate }}</span>
                    @if (!showEditorialDepartment()) {
                        <span class="material-icons">expand_more</span>
                    }
                    @if (showEditorialDepartment()) {
                        <span class="material-icons">expand_less</span>
                    }
                </button>
            </div>
            <div>{{ 'app.latesDataDate' | translate }}: {{ lastupdate() }} UTC</div>
        </div>
    </div>
    @if (isExpanded()) {
        <div class="links-section__content">
            @if (showRegionalContacts()) {
                <div><app-contact-regional [regionalcontacts]="regionalcontacts()"></app-contact-regional></div>
            }
            @if (showEditorialDepartment()) {
                <div><app-editorial-staff [editorialdepartment]="editorialdepartment()"></app-editorial-staff></div>
            }
        </div>
    }
</div>
